import Image from 'next/image';
import { useMemo } from 'react';

import { EventTriggerType, HypurrCardOperationType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const HypurrCardTransactionsTriggerDetails = ({ trigger, triggerType }: Props) => {
  const operationTypeLabel = useMemo(() => {
    const operationType = trigger.context?.operationType;
    return operationType === HypurrCardOperationType.Borrow
      ? 'Borrow'
      : operationType === HypurrCardOperationType.Withdraw
        ? 'Withdraw'
        : '';
  }, [trigger.context]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerValueDetail
        label="Network"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/svg/hyperevm.svg" width={12} height={12} alt="HyperEVM" />
            <span>HyperEVM</span>
          </div>
        }
      />

      <TriggerValueDetail label="Operation Type" value={operationTypeLabel} />
    </div>
  );
};
